import React from 'react';

const Aboutme = () => {
	return (
		<div className='container'>
			<h1 className='animate__animated animate__fadeInUp'>About me</h1>
		</div>
	);
};

export default Aboutme;
